module.exports = __webpack_public_path__ + "res/prediction.43f849db6adcaf5f73b1a453b6a7a95a.webp";